import type { DistributionRange } from "@/pages/home/lib/ranges";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const parts = (value: string) => {
  const [year, month, day] = value.split("-").map(Number);
  return { year, month: MONTHS[month - 1], day };
};

const dayMonth = (value: string) => `${parts(value).day} ${parts(value).month}`;
const dayMonthYear = (value: string) => `${dayMonth(value)} ${parts(value).year}`;
const monthDay = (value: string) => `${parts(value).month} ${parts(value).day}`;
const monthDayYear = (value: string) => `${monthDay(value)}, ${parts(value).year}`;

const sameYear = (from: string, to: string) => from.slice(0, 4) === to.slice(0, 4);

const PRESET_PHRASE: Record<"7d" | "30d", string> = { "7d": "last 7 days", "30d": "last 30 days" };

export const customRangeTitle = (from: string, to: string): string => {
  const start = sameYear(from, to) ? dayMonth(from) : dayMonthYear(from);
  return `${start} – ${dayMonthYear(to)}`;
};

export const periodTitle = (range: DistributionRange): string =>
  range.id === "custom" ? customRangeTitle(range.from, range.to) : PRESET_PHRASE[range.id];

export const heroWhen = (range: DistributionRange): string => {
  if (range.id !== "custom") return `in the ${PRESET_PHRASE[range.id]}`;
  const format = sameYear(range.from, range.to) ? dayMonth : dayMonthYear;
  return `between ${format(range.from)} and ${format(range.to)}`;
};

export const comparisonPhrase = (range: DistributionRange): string =>
  range.id === "custom" ? "the previous period" : `the previous ${range.id === "7d" ? "7" : "30"} days`;

export const comparisonDates = (prior: { from: string; to: string }): string => {
  const format = sameYear(prior.from, prior.to) ? monthDay : monthDayYear;
  return `vs ${format(prior.from)} – ${format(prior.to)}`;
};
